import { useEffect, useState } from 'react';

const TOUR_IFRAME_ALLOW =
  'accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; magnetometer; microphone; picture-in-picture; web-share; xr-spatial-tracking';

const  tourUrl = "https://www.zillow.com/view-imx/41e8ccb1-a0d6-432a-8ff1-2a11c7802f57?setAttribution=mls&wl=true&initialViewType=pano&utm_source=dashboard"


export default function TourSection ( ){
  const [embedSrc, setEmbedSrc] = useState(null);

  useEffect(() => {
    setEmbedSrc(null);
    if (!tourUrl?.trim()) return;
    // Defer assigning src until after paint so React Strict Mode’s mount→unmount→remount
    // does not kick off two Zillow loads back-to-back (often breaks or rate-limits the embed).
    let cancelled = false;
    let raf2 = 0;
    const raf1 = window.requestAnimationFrame(() => {
      raf2 = window.requestAnimationFrame(() => {
        if (!cancelled) setEmbedSrc(tourUrl.trim());
      });
    });
    return () => {
      cancelled = true;
      window.cancelAnimationFrame(raf1);
      window.cancelAnimationFrame(raf2);
    };
  }, [tourUrl]);

  if (!tourUrl?.trim()) {
    return (
      <section className="section" id="tour">
        <h2 className="section__title">3D Tour</h2>
        <p className="tour-offline">
          This self-contained build does not embed the original hosted 3D tour. Contact the listing agent if you need a
          live virtual tour.
        </p>
      </section>
    );
  }

  const openUrl = tourUrl.trim();

  return (
    <section className="section" id="tour">
      <h2 className="section__title">3D Tour</h2>
      <p className="tour-open-hint">
        <a className="tour-open-btn" href={openUrl} target="_blank" rel="noreferrer">
          Open 3D tour in a new tab
        </a>
        <span className="tour-open-hint__sub">Best if the viewer below stays blank (common on localhost or with strict privacy settings).</span>
      </p>
      <div className="tour-frame-wrap">
        {embedSrc ? (
          <iframe
            title="3D virtual tour"
            src={embedSrc}
            className="tour-frame"
            allow={TOUR_IFRAME_ALLOW}
            allowFullScreen
            loading="lazy"
          />
        ) : (
          <div className="tour-frame tour-frame--loading" aria-hidden />
        )}
      </div>
      <p className="tour-fallback">
        If the tour does not load here,{' '}
        <a href={openUrl} target="_blank" rel="noreferrer">
          open the 3D tour in a new tab
        </a>
        .
      </p>
    </section>
  );
}
